<template>
    <div v-if="showOrderFinishForm" class="row pb-md-2">
        <div class="col-12 text-center">
            <h4>
                {{ $t('bookingService.order_mode.text') }}
                <br/>
                {{ $t('bookingService.order_mode.text2') }}
                <span class="tooltip" v-if="tooltipVisible">
                    Sie haben Ihren Kauf nicht bei uns getätigt. Wir müssen daher sicherstellen, dass Sie das korrekte Produkt erhalten. Dies dient Ihrer Sicherheit.
                </span>
                <InfoIcon class="info-icon" @mouseover="showTooltip" @mouseout="hideTooltip"/>
            </h4>
        </div>
        <div class="col-12 pt-3">
            <OrderDetails :data="orderDetails" />
            <p>
                Falsches Produkt? Wenden Sie sich an unseren Kundensupport: <a href="tel:+4922193374100">0221 - 933 74 100</a>
            </p>
        </div>
        <div class="col-12">
            <FinishOrderForm  @submit="finishOrderProcess" :is-sending="isSendingData"/>
            <small>
                Ich habe die <a href="https://www.animod.de/c/agb" target="_blank">AGB</a> und die <a href="https://www.animod.de/c/datenschutz" target="_blank">Datenschutzerklärung</a> von Animod gelesen und akzeptiere diese. Zusätzlich wird
                Ihre E-Mail-Adresse für unseren Newsletter verwendet, von dem Sie sich selbstverständlich
                jederzeit kostenfrei abmelden können.
            </small>
        </div>
    </div>
    <div v-else-if="voucher.personalDataRequired" class="row pb-md-2">
        <div class="col-12">
            <p class="card-text">{{ $t('voucherStatus.supporting_text.generic.status.personalDataRequired.text') }}</p>

            <ContactForm @submit="savePersonalData" :is-sending="isSendingData" :showNewsletterCheckbox="true" :sendVoucher="true"/>

            <CustomerServiceBlock/>
        </div>
    </div>
    <div v-else-if="!showContactForm" class="row py-md-4">
        <div v-if="isOrderMode" class="col-12 text-center">
            <h4>Vielen Dank!</h4>
        </div>
        <div class="col-12">
            <p class="card-text">
                {{
                    $t('bookingService.mode.text')
                }}
            </p>
        </div>

        <div class="col-12 text-center pt-4">
            <button class="btn btn-primary" @click="proceedToNextStep">
                {{
                    $t('bookingService.mode.button.proceed')
                }}
            </button>
        </div>

        <div class="col-12 text-center pt-3 mt-3">
            <button @click="showContactForm = true" class="btn btn-secondary btn-sm text-nowrap">
                {{
                    $t('bookingService.mode.button.send')
                }}
            </button>
        </div>
        <div class="col-12 pt-3">
            <external-incentive-block :incentive-data="externalIncentive" :code="$store.getters.voucherCode"/>
        </div>
    </div>

    <div v-else>
        <ContactForm v-if="!dataIsSent" @submit="contactSubmit" :is-sending="isSendingData"
                     :showNewsletterCheckbox="true"  :sendVoucher="true">
        </ContactForm>

        <div v-else>
            <h1 class="card-title h5">{{ $t('common.dear_guest') }}</h1>
            <p class="card-text">
                {{ $t('bookingServiceSuccess.supporting_text.common.success_message.text') }}
            </p>
            <p class="card-text">
                {{
                    $t('bookingService.mode.success.text')
                }}
            </p>
            <i18n path="bookingServiceSuccess.supporting_text.common.customer_support.text" tag="p"
                  class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
            <div class="card-navigation">
                <button class="btn btn-secondary" @click="$store.dispatch('reset')">
                    {{ $t('common.redeem_another_voucher') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import InfoIcon from "../../../animod-shop-ssr/src/assets/icons/info.svg";
import ContactForm from '@/components/ContactForm'
import CustomerServiceEmail from '../components/CustomerServiceEmail'
import CustomerServicePhone from '../components/CustomerServicePhone'
import ExternalIncentiveBlock from '../components/ExternalIncentiveBlock'
import FinishOrderForm from "@/components/FinishOrderForm.vue";
import OrderDetails from "@/components/OrderDetails.vue";
import CustomerServiceBlock from "./CustomerServiceBlock.vue";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'BookableHotelVoucherMode',
    components: {
        CustomerServiceBlock,
        FinishOrderForm, ContactForm, CustomerServiceEmail, CustomerServicePhone, ExternalIncentiveBlock, OrderDetails, InfoIcon },
    data () {
        return {
            tooltipVisible: false,
            showContactForm: false,
            isSendingData: false,
            dataIsSent: false
        }
    },
    props: {},
    computed: {
        ...mapState(['voucher']),
        ...mapGetters(['voucherCode']),
        showOrderFinishForm() {
            return this.$store.state.voucher.voucherPortalNewsletterMode === 'LastOrderStep'
                        && this.$store.state.voucher.personalDataRequired
                        && this.$store.state.voucher.productInformation;
        },
        isOrderMode() {
            return this.$store.state.voucher.voucherPortalNewsletterMode === 'LastOrderStep';
        },
        externalIncentive() {
            return this.voucher.externalIncentiveInfo;
            //return this.$store.state.voucher.externalIncentiveInfo;
        },
        orderDetails() {
            return this.$store.state.voucher.productInformation;
        }
    },
    methods: {
        showTooltip() {
            this.tooltipVisible = true;
        },
        hideTooltip() {
            this.tooltipVisible = false;
        },
        savePersonalData (contactData) {
            try {
                this.isSendingData = true
                this.$store.dispatch('savePersonalData', {
                    ...contactData,
                    voucherCode: this.voucherCode
                });
                this.isVoucherInfoFormSubmitted = true
            } finally {
                this.isSendingData = false
            }
        },
        async contactSubmit (contactData) {
            console.log("contactSubmit");
            this.isSendingData = true
            try {
                const voucherCode = this.$store.getters.voucherCode;
                const response = await this.$store.dispatch('sendContactForm', {
                    ...contactData,
                    voucherCode,
                    sendVoucher: true
                })
                this.dataIsSent = true
            } finally {
                this.isSendingData = false
            }
        },
        async finishOrderProcess (contactData) {
            console.log("finishOrderProcess", contactData);
            this.isSendingData = true
            try {
                const voucherCode = this.$store.getters.voucherCode;
                const response = await this.$store.dispatch('finishOrderProcess', {
                    ...contactData,
                    voucherCode,
                    sendVoucher: true
                })
                this.dataIsSent = true
            } finally {
                this.isSendingData = false
            }
        },
        proceedToNextStep() {
            this.$emit('proceed');
        }
    }
}
</script>

<style scoped lang="scss">
h4 {
    color: #525252;
    display: block;
    font-size: 1.5rem;
    margin: 0.625rem auto;
    text-align: center;
}
.tooltip-container {
    display:inline-block;
    width:20px;
    height:20px;
}
.info-icon {
    display:inline-block;
    width:20px;
    height:20px;
    color:#525252;
    fill:#525252;
}
.tooltip {
    color: #000;
    background-color: #fff;
    will-change: transform;
    top: -60px;
    left: 240px;
    position: absolute;
    border-radius: 2px;
    padding: 6px 10px;
    box-shadow: 0px 0px 3px rgba(#666, 0.8);
    max-width: 320px;
    z-index: 100;
    display:block;
    opacity: 1;
}
</style>
